export const faq_Marketplaces = [
	{
		icon: '💬',
		title: 'faqData_title1',
		subtitle: 'faqData_subtitle1',
	},
	{
		icon: '💬',
		title: 'faqData_title2',
		subtitle: 'faqData_subtitle2',
	},
	{
		icon: '💬',
		title: 'faqData_title3',
		subtitle: 'faqData_subtitle3',
		underSubtitle: 'faqData_underSubtitle3',
	},
];
